import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import "../../Common/Styles/Listing.css";
import search from "../../assets/images/search-lg.svg";
import ContactHeader from "./ContactHeader";
import {
  getContactusListingData,
  updateContactusStatus,
} from "../../../redux/contactus/action";
import CommonPagination from "../../Common/Pagination/CommonPagination";

const ContactusListing = () => {
  const [params, setParams] = useState({
    page: 1,
    search_key: "",
  });
  const [openFilter, setOpenFilter] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const contactusListing = useSelector(
    (state) => state?.bookingSlice?.getContactusListing
  );
  console.log(contactusListing, "masdfsf");

  useEffect(() => {
    dispatch(getContactusListingData(params));
  }, [dispatch, params]);

  const handleClickOneItem = (item) => {
    const payload = {
      id: item,
      status: 1,
    };
    dispatch(updateContactusStatus(payload));
  };

  return (
    <Card className="col-md-12">
      <div
        onClick={() => setOpenFilter(false)}
        className={openFilter ? "overlay show" : "overlay"}
      ></div>
      <ContactHeader
        params={params}
        setParams={setParams}
        // addmodel={addComponent}
        search={search}
        setOpenFilter={setOpenFilter}
      />
      <div className="content-area">
        <div className="table-sec">
          <table className="report-table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>Name</th>
                <th>Message</th>
                <th>Subject</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {contactusListing?.contact_list?.length > 0 ? (
                contactusListing?.contact_list?.map((item, index) => (
                  <tr key={index}>
                    <td> {index + 1 + (params?.page - 1) * 10}</td>
                    <td> {item?.full_name}</td>
                    <td>{item?.message}</td>
                    <td>{item?.subject}</td>
                    <td>
                      {item?.status == 0
                        ? <button className="contactus">New</button>
                        : item?.status == 1
                        ? "Completed"
                        : ""}
                    </td>
                    <td>
                     { item?.status==0?<button
                        onClick={() => {
                          handleClickOneItem(item?.id);
                        }}
                        className="buttons background-button"
                      >
                        <span>Update</span>
                      </button>:"-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="no-reports text-center">
                    No Request found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <CommonPagination
            params={params}
            setParams={setParams}
            pagination_meta={contactusListing?.pagination_meta}
          />
        </div>
      </div>
    </Card>
  );
};

export default ContactusListing;
